/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DataVaxiomInsuranceCarrierForm/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Address from './Address/index'
import CancelAction from './CancelAction/index'
import ContinuationClaims from './ContinuationClaims/index'
import Electronically from './Electronically/index'
import InstallmentInterval from './InstallmentInterval/index'
import Medicaid from './Medicaid/index'
import Name from './Name/index'
import Phone from './Phone/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useListItemDataOnChange from './useListItemDataOnChange.js'



/** @type {import('Simple/types.js').View} */
export default function DataVaxiomInsuranceCarrierForm({
  children,
  viewPath = "/DesignSystem/DataVaxiomInsuranceCarrierForm"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let carrierInsuranceCompanyPhoneAssociationsValueData = fromData.useDataValue({ viewPath,
context: 'carrier',
path: 'insurance_company_phone_associations',
})
  return (<React.Fragment
>
<div
  data-testid="DataVaxiomInsuranceCarrierForm.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-1gY03C': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-1gY03C': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<InstallmentInterval
  viewPath={`${viewPath}/InstallmentInterval`}
/>
<ContinuationClaims
  viewPath={`${viewPath}/ContinuationClaims`}
/>
<Medicaid
  viewPath={`${viewPath}/Medicaid`}
/>
<Electronically
  viewPath={`${viewPath}/Electronically`}
/>
<Address
  viewPath={`${viewPath}/Address`}
/>
<div
  data-testid="DataVaxiomInsuranceCarrierForm.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-3-1gY03C': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-4-1gY03C': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="DataVaxiomInsuranceCarrierForm.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Phone Numbers"
/>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 size="small"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="+ Add"
/>
)}
</TysiaButton>
</div>
<div
  data-testid="DataVaxiomInsuranceCarrierForm.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(carrierInsuranceCompanyPhoneAssociationsValueData) && carrierInsuranceCompanyPhoneAssociationsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="phone"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Phone(${item?.id ?? item?._id ?? index})`}
      >
<Phone
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Phone(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
</div>
<div
  data-testid="DataVaxiomInsuranceCarrierForm.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pl-1-1gY03C': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-1gY03C': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-5-1gY03C': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal1}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    let onChange = useListItemDataOnChange({ ...props, viewPath: props.parentViewPath })
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      onChange={onChange}
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }